import {createTheme, ThemeOptions} from '@mui/material/styles';

export const themeOptions: ThemeOptions = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#83659c',
        },
        secondary: {
            main: '#dbf0f2',
        },
        warning: {
            main: '#fad371',
        },
    },
    typography: {
        "fontFamily": `"Scout", "Roboto", "Helvetica", "Arial", sans-serif`,
        "fontWeightLight": 200,
        "fontWeightRegular": 300,
        "fontWeightMedium": 400,
        "fontSize": 16,
    },
});